<template>
  <slot></slot>
</template>

<script setup lang="ts">
/**
 * A wrapper component used when rendering a paragraph via <BlokkliItem>
 * outside of a <BlokkliField> and <BlokkliProvider>.
 */
import {
  INJECT_FIELD_LIST_BLOCKS,
  INJECT_PROVIDER_BLOCKS,
} from '#blokkli/helpers/symbols'

const list = computed(() => [])

provide(INJECT_FIELD_LIST_BLOCKS, list)
provide(INJECT_PROVIDER_BLOCKS, list)
</script>
